import { CommonModule } from '@angular/common';
import {
    Component,
    ContentChildren,
    QueryList,
    Input,
    Output,
    EventEmitter,
    NgModule,
    input,
    OnDestroy,
    AfterContentInit,
    SimpleChanges,
    OnChanges,
} from '@angular/core';

import { TabComponent } from './tab.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'rs-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    standalone: false
})
export class TabsComponent implements AfterContentInit, OnDestroy, OnChanges {
    public css = input<string>();
    public tabHeaderCss = input<string>();
    public wrapperContainer = input('mb-4 nav nav-tabs no-gutters');
    @Output() public getActiveTab: EventEmitter<any> = new EventEmitter();
    @ContentChildren(TabComponent) public tabChildren: QueryList<TabComponent>;
    private hasInitializedTabs = false;
    private lastActiveIndex: number;
    private _initialTab: number = 0;
    @Input()
    set initialTab(value: number) {
        this._initialTab = value;
        this.setInitialTabIfReady();
    }
    get initialTab(): number {
        return this._initialTab;
    }
    private tabChangesSub: Subscription;

    ngAfterContentInit(): void {
        this.hasInitializedTabs = true;
        this.tabChangesSub = this.tabChildren.changes.subscribe(() => {
            this.setInitialTabIfReady();
        });
        this.setInitialTabIfReady();
    }

    ngAfterViewChecked(): void {
        // get all active tabs
        setTimeout(() => this.resetActiveTab());
    }

    private setInitialTabIfReady() {
        const tabs = this.tabs;
        if (!this.hasInitializedTabs || !tabs?.length) return;

        this.setActiveTab(this._initialTab);
    }

    ngOnDestroy(): void {
        this.tabChangesSub?.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['activeTab']) {
            console.log(this.initialTab);
            this.setActiveTab(this.initialTab);
        }
    }

    private resetActiveTab() {
        const activeTabs = this.tabs.filter((tab) => tab.active);
        // if there is no active tab set, activate the first
        if (activeTabs.length === 0) {
            this.setActiveTab(this.lastActiveIndex ?? 0);
        }
    }

    get tabs() {
        return this.tabChildren && this.tabChildren.toArray();
    }

    public setActiveTab(index: number): void {
        const tabs = this.tabs;
        if (!tabs || !tabs[index]) return;

        for (let i = 0; i < tabs.length; i++) {
            tabs[i].active = i === index;
        }

        this.lastActiveIndex = index;
        this.getActiveTab.emit({ tab: tabs[index], i: index });
    }
}
@NgModule({
    imports: [CommonModule],
    declarations: [TabComponent, TabsComponent],
    exports: [TabComponent, TabsComponent],
})
export class TabsComponentModule {}
